import { render, staticRenderFns } from "./ConsultList.vue?vue&type=template&id=cbcc0520&scoped=true"
import script from "./ConsultList.vue?vue&type=script&lang=js"
export * from "./ConsultList.vue?vue&type=script&lang=js"
import style0 from "./ConsultList.vue?vue&type=style&index=0&id=cbcc0520&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbcc0520",
  null
  
)

export default component.exports